import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    id: {
      title: 'Identyfikator konkursu',
      type: 'number'
    },
    name: {
      title: 'Nazwa konkursu',
      type: 'string',
      fieldRequired: true
    },
    declination: {
      title: 'Deklinacja',
      type: 'object',
      properties: {
        miejscownik: {
          type: 'string',
          title: 'Miejscownik',
          fieldRequired: false
        },
        dopelniacz: {
          type: 'string',
          title: 'Dopełniacz',
          fieldRequired: false
        }
      }
    },
    type: {
      title: 'Typ',
      type: 'string',
      fieldRequired: true
    },
    level: {
      title: 'Poziom',
      type: 'string',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
